<template>
  <form v-if="fund">

    <div class="row">
      <div class="col-md-12">
        <!-- Custom Tabs -->
        <div class="nav-tabs-custom">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#tab_1" data-toggle="tab">Identificazione fondo</a>
            </li>
            <li><a href="#tab_2" data-toggle="tab">Descrizione fondo</a></li>
            <li><a href="#tab_3" data-toggle="tab">Intervista</a></li>
            <li><a href="#tab_4" data-toggle="tab">Archivio web</a></li>

            <li class="pull-right" v-show="showSave">
              <button class="btn btn-success btn-block" v-if="!disabled"
                      v-on:click.prevent="save">
                <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                Salva
              </button>

              <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                      v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                Attiva modifiche
              </button>
            </li>
            <li class="pull-right" v-show="showSearch">
              <button class="btn btn-success btn-block" v-if="!disabled" v-on:click.prevent="search">
                <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                Cerca
              </button>
            </li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="tab_1">
              <div class="row">
                <div class="col-md-6">

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="denominazione">Denominazione</label>
                        <input type="text" class="form-control" id="denominazione"
                               name="denominazione"
                               v-model="fund.denominazione" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="consistenza">Consistenza</label>
                        <input type="number" class="form-control" id="consistenza"
                               name="consistenza"
                               v-model="fund.consistenza" disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Formati</label>
                        <br/>
                        <span v-for="format in fund.filmFormats.data" class="multiselect__tag">
                                                <span>{{ format.name }}</span>
                                              </span>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group" style="margin-bottom: 40px;">
                        <label for="slider">Anno inizio e fine</label>
                        <vue-slider id="slider" ref="slider" v-model="fund.range_anni" :min="1920"
                                    :max="1990"
                                    tooltip-dir="bottom" :disabled="true"></vue-slider>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="durata">Durata totale fondo (h/m/s)</label>
                        <input type="text" v-model="fund.durata" class="form-control" id="durata"
                               name="durata" :disabled="true"/>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="lunghezza">Lunghezza totale fondo in metri</label>
                        <input type="text" class="form-control" id="lunghezza"
                               name="lunghezza"
                               v-model="fund.lunghezza" :disabled="true">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="conservazione_stato">Stato di conservazione generale</label>
                        <select v-model="fund.conservazione_stato" class="form-control"
                                id="conservazione_stato"
                                name="conservazione_stato" :disabled="disabled">
                          <option></option>
                          <option v-for="(stato, id) in conservazione_stati"
                                  v-bind:value="id">
                            {{ stato }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="digitalizzazione">Digitalizzazione</label>
                        <input type="text" class="form-control" id="digitalizzazione"
                               name="digitalizzazione"
                               v-model="fund.digitalizzazione" :disabled="true">
                      </div>
                    </div>
                  </div>

                  <div class="row" v-if="!fund.isNew">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="catalogazione">Catalogazione</label>
                        <input type="text" class="form-control" id="catalogazione"
                               name="catalogazione"
                               v-model="fund.catalogazione" :disabled="true">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="note_generali">Note</label>
                        <textarea v-model="fund.note_generali" class="form-control"
                                  id="note_generali"
                                  name="note_generali"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-divider"></div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="acquisizione_data">Data acquisizione</label>
                        <date-picker class="form-control" id="acquisizione_data"
                                     name="acquisizione_data"
                                     v-model="fund.acquisizione_data" @dp-error="error"
                                     :config="config"
                                     :disabled="disabled"></date-picker>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="acquisizione_tipo">Tipologia acquisizione</label>
                        <select v-model="fund.acquisizione_tipo" class="form-control"
                                id="acquisizione_tipo"
                                name="acquisizione_tipo" :disabled="disabled">
                          <option></option>
                          <option v-for="(donazione_tipo, id) in donazione_tipi"
                                  v-bind:value="id">
                            {{ donazione_tipo }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="donors">Titolare/i del fondo</label>

                        <multiselect
                          v-model="fund.donors.data"
                          :options="persons"
                          :multiple="true"
                          track-by="id"
                          label="nome"
                          placeholder="seleziona"
                          SelectLabel="seleziona"
                          SelectedLabel="selezionato"
                          DeselectLabel="deseleziona"
                          id="donors"
                          name="donors"
                          :disabled="disabled"
                          :clear-on-select="false"
                          :searchable="true"
                          @search-change="personsFind">
                        </multiselect>

                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="collocazione">Collocazione pellicole</label>
                        <input type="text" class="form-control" id="collocazione"
                               name="collocazione"
                               v-model="fund.collocazione" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nas_collocazione">Collocazione nas</label>
                        <input type="text" class="form-control" id="nas_collocazione"
                               name="nas_collocazione"
                               v-model="fund.nas_collocazione" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nas_collocazione">Collocazione lto</label>
                        <input type="text" class="form-control" id="lto_collocazione"
                               name="lto_collocazione"
                               v-model="fund.lto_collocazione" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="acquisizione_note">Note</label>
                        <textarea v-model="fund.acquisizione_note" class="form-control"
                                  id="acquisizione_note"
                                  name="acquisizione_note"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-divider"></div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="storia_archivistica">Storia archivistica</label>
                        <textarea v-model="fund.storia_archivistica" class="form-control"
                                  id="storia_archivistica"
                                  name="storia_archivistica"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="criteri_ordinamento">Criteri di ordinamento</label>
                        <input type="text" class="form-control" id="criteri_ordinamento"
                               name="criteri_ordinamento"
                               v-model="fund.criteri_ordinamento" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="condizione_giuridica">Condizione giuridica</label>
                        <textarea v-model="fund.condizione_giuridica" class="form-control"
                                  id="condizione_giuridica"
                                  name="condizione_giuridica"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="materiali_aggiuntivi">Materiali aggiuntivi</label>
                        <textarea v-model="fund.materiali_aggiuntivi" class="form-control"
                                  id="materiali_aggiuntivi"
                                  name="materiali_aggiuntivi"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="note_archivista">Note archivista</label>
                        <textarea v-model="fund.note_archivista" class="form-control"
                                  id="note_archivista"
                                  name="note_archivista"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <!--image handle-->
                <div class="col-md-6" v-if="showLabels">
                  <div class="row">
                    <div class="col-md-12">
                      <ul id="gallery">
                        <li v-for="image in fund.fundimages.data">
                          <a :href="image.url" target="_blank">
                            <img :src="image.url"
                                 class="img-responsive"/>
                          </a>

                          <button class="btn btn-xs btn-danger"
                                  v-on:click.prevent="delImage(image.id)"
                                  v-show="!disabled">
                            <i class="fa fa-remove"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <dropzone :style="{ border: '2px dashed', height: '200px', width: '100%' }"
                                :uploader="uploader" v-show="!disabled"/>
                      <span class="text-bold"
                            v-show="!disabled">Trascina qui i file da caricare</span>
                    </div>
                  </div>
                </div>
                <!--/.image-handle-->
              </div>
            </div>
            <!-- /.tab-pane -->

            <div class="tab-pane" id="tab_2">

              <div class="row">
                <div class="col-md-6">

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="abstract">Descrizione fondo</label>
                        <textarea v-model="fund.abstract" class="form-control" id="abstract"
                                  name="abstract"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="note_biografiche">Profilo biografico cineamatore</label>
                        <textarea v-model="fund.note_biografiche" class="form-control"
                                  id="note_biografiche"
                                  name="note_biografiche"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="note_descrizione">Note</label>
                        <textarea v-model="fund.note_descrizione" class="form-control"
                                  id="note_descrizione"
                                  name="note_descrizione"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-md-6">
                </div>
              </div>
            </div>
            <!-- /.tab-pane -->

            <div class="tab-pane" id="tab_3">
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="intervista">È stata realizzata un'intervista?</label>
                        <select v-model="fund.intervista" class="form-control"
                                id="intervista"
                                name="intervista" :disabled="disabled">
                          <option></option>
                          <option v-for="(desc, id) in ynp"
                                  v-bind:value="id">
                            {{ desc }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="intervista_collocazione">Collocazione intervista</label>
                        <input type="text" class="form-control" id="intervista_collocazione"
                               name="intervista_collocazione"
                               v-model="fund.intervista_collocazione" :disabled="disabled">
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="interviewers">Intervistatore/i</label>

                        <multiselect
                          v-model="fund.interviewers.data"
                          :options="persons"
                          :multiple="true"
                          track-by="id"
                          label="nome"
                          placeholder="seleziona"
                          SelectLabel="seleziona"
                          SelectedLabel="selezionato"
                          DeselectLabel="deseleziona"
                          id="interviewers"
                          name="interviewers"
                          :disabled="disabled"
                          :clear-on-select="false"
                          :searchable="true"
                          @search-change="personsFind">
                        </multiselect>

                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="persone_intervistate">Persone intervistate</label>
                        <textarea v-model="fund.persone_intervistate" class="form-control"
                                  id="persone_intervistate"
                                  name="persone_intervistate"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                </div>
              </div>
            </div>
            <!-- /.tab-pane -->

            <div class="tab-pane" id="tab_4">

              <div class="row">
                <div class="col-md-6">

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nome">Da pubblicare?</label>
                        <input type="radio" name="web_enabled" value="0" v-model="fund.web_enabled"
                               :disabled="disabled"/> No
                        <input type="radio" name="web_enabled" value="1" v-model="fund.web_enabled"
                               :disabled="disabled"/> Sì
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="web_description">Descrizione fondo</label>
                        <textarea v-model="fund.web_description" class="form-control" id="web_description"
                                  name="web_description"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="web_filmmaker_bio">Profilo biografico cineamatore</label>
                        <textarea v-model="fund.web_filmmaker_bio" class="form-control"
                                  id="web_filmmaker_bio"
                                  name="web_filmmaker_bio"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="web_note">Note</label>
                        <textarea v-model="fund.web_note" class="form-control"
                                  id="web_note"
                                  name="web_note"
                                  :disabled="disabled"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="web_note">Immagine in evidenza</label>
                        <div class="row">
                          <div class="col-md-4" v-for="image in fund.fundimages.data">
                            <a :href="image.url" target="_blank">
                              <img :src="image.url"
                                   class="img-responsive" style="width: 100%;"/>
                            </a>
                            <input type="radio" name="web_top_image" v-model="fund.web_top_image" :value="image.id" :disabled="disabled">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-warning btn-block" v-on:click.prevent="saveArchiveWeb"
                              v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                        Salva info archivio web
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                </div>
              </div>
            </div>
            <!-- /.tab-pane -->
          </div>
          <!-- /.tab-content -->

          <div class="box-footer">
            <ul class="nav">
              <li class="pull-right" v-show="showSave">
                <button class="btn btn-success btn-block" v-if="!disabled"
                        v-on:click.prevent="save">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                  Salva
                </button>

                <button class="btn btn-warning btn-block" v-on:click.prevent="activateMod"
                        v-if="disabled && $accessControl.isOperator($store.state.profile.profile)">
                  Attiva modifiche
                </button>
              </li>
              <li class="pull-right" v-show="showSearch">
                <button class="btn btn-success btn-block" v-if="!disabled" v-on:click.prevent="search">
                  <i class="fa fa-circle-o-notch fa-spin" v-if="loader"></i>
                  Cerca
                </button>
              </li>
            </ul>
          </div>

        </div>
        <!-- nav-tabs-custom -->
      </div>
    </div>

  </form>
</template>

<script>
import {clientDateFormat} from '../../filters'
import personsApi from '../../api/persons'
import fundsApi from '../../api/funds'
import filmformatApi from '../../api/filmformat'
import vueSlider from 'vue-slider-component'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import Dropzone from 'vue-fineuploader/dropzone'
import MaskedInput from 'vue-masked-input'

// Import this component
import datePicker from 'vue-bootstrap-datetimepicker'

// Import date picker css
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  props: ['disabled', 'fund', 'loader', 'showLabels', 'showSearch', 'showSave'],
  methods: {
    save () {
      this.$emit('click', this.fund)
    },
    error (e) {
      console.log(e)
    },
    activateMod () {
      this.$emit('activate-mod', this.fund)
    },
    saveArchiveWeb () {
      this.$emit('save-archive-web', this.fund)
    },
    search () {
      this.$emit('search', this.fund)
    },
    delImage (id) {
      fundsApi.deleteImage(this.fund.id, id)
        .then((response) => {
          this.fund.fundimages = response.data.data.fundimages
          toastr.success('L\'immagine è stata rimossa correttamente')
        })
        .catch((response) => {
        })
    },
    personsFind (query) {
      personsApi.select(query)
        .then((response) => {
          this.persons = response.data.data
        })
    }
  },
  data () {
    return {
      config: {
        format: clientDateFormat
      },
      persons: [],
      formati: [],
      uploader: new FineUploaderTraditional({
        options: []
      })
    }
  },
  watch: {
    fund: function (val) {
      this.uploader = new FineUploaderTraditional({
        options: {
          request: {
            endpoint: process.env.BASE_URL + '/funds/' + val.id + '/fundimage',
            customHeaders: {
              'Authorization': 'Bearer ' + sessionStorage.getItem('access_token')
            },
            inputName: 'image'
          },
          callbacks: {
            onComplete: (id, name, response) => {
              this.fund.fundimages = response.data.fundimages
            }
          }
        }
      })
    }
  },
  computed: {
    donazione_tipi () {
      return this.$store.state.decoder.decoders['_dDonationTypes']
    },
    conservazione_stati () {
      return this.$store.state.decoder.decoders['_dConservationState']
    },
    ynp () {
      return this.$store.state.decoder.decoders['_dYesNoPartial']
    }
  },
  beforeCreate () {
    filmformatApi.index()
      .then((response) => {
        this.formati = response.data.data
      })
  },
  components: {
    datePicker,
    Multiselect,
    vueSlider,
    Dropzone,
    MaskedInput
  }
}
</script>

<style scoped>
.form-divider {
  background-color: rgb(138, 163, 157);
}

#gallery {
  position: relative;
  padding: 0px;
}

#gallery li {
  list-style: none;
  position: relative;
  margin-bottom: 10px;
}

#gallery button {
  position: absolute;
  bottom: 0px;
  right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/funds/Form.vue